// This file is automatically generated. DO NOT EDIT.

import { type TextResult } from '../../../../types/response/TextResult';
import { getJSONResponse, type GetJSONResponseOptions } from '@api/internal';

export interface GetTextResultsResponse {
  /** The results */
  results: Array<TextResult>;
}

export async function getTextResultsResponse(
  response: Response,
  options?: GetJSONResponseOptions<GetTextResultsResponse>,
): Promise<GetTextResultsResponse> {
  return getJSONResponse<GetTextResultsResponse>(
    response,
    'getTextResultsResponse',
    options,
  );
}
